<template>
  <div class="nettdoc-personal-information">
    <h2 class="nettdoc-header nettdoc-personal-information__header">{{ $t('Personal information') }}</h2>
    <p class="nettdoc-personal-information__intro">
      {{
        $t('Please give more information about yourself, so that the doctor could know better about your medical history and give a accurate diagnose.')
      }}
    </p>
    <p class="nettdoc-personal-information__intro">
      {{
        $t('Considering the Information privacy policy, your real full name will not be asked in this anamnese sheet. Please show your name directly to the doctor while the diagnose.')
      }}
    </p>

    <SectionHeader text="Gender" :required="true" :dark="true" />
    <Dropdown
      label="Gender"
      :data="['Male', 'Female', 'Other']"
      :choice="store.patientInformation.gender"
      v-on:action="value => store.addPatientInformation('gender', value)"
    />

    <SectionHeader text="Age" :required="true" :dark="true" />
    <NumberInput
      label="Age"
      :showLabel="true"
      :model="store.patientInformation.age"
      v-on:action="value => store.addPatientInformation('age', value)"
    />

    <SectionHeader text="Height in centimetres" :required="true" :dark="true" />
    <NumberInput
      label="cm"
      :showLabel="true"
      :model="store.patientInformation.height"
      v-on:action="value => store.addPatientInformation('height', value)"
    />

    <SectionHeader text="Weight in kilograms" :required="true" :dark="true" />
    <NumberInput
      label="kg"
      :showLabel="true"
      :model="store.patientInformation.weight"
      v-on:action="value => store.addPatientInformation('weight', value)"
    />

    <SectionHeader text="Since when are you in Germany?" :required="true" :dark="true" />
    <Dropdown
      label="months"
      :data="['less than 1 month', '1 month', '2 months', '3 months', '4 months', '5 months', 'more than 5 months']"
      :choice="store.patientInformation.inGermanySince"
      v-on:action="value => store.addPatientInformation('inGermanySince', value)"
    />

    <SectionHeader text="How did you get to Germany?" :required="true" :dark="true" />
    <Dropdown
      label="please choose"
      :data="['Eastern land route', 'Western Balkan route', 'Mediterranean route', 'Apulia / Calabria', 'West-African route']"
      :choice="store.patientInformation.wayToGermany"
      v-on:action="value => store.addPatientInformation('wayToGermany', value)"
    />

    <Button
      :text="edit ? 'Update' : 'Submit'"
      :active="store.patientInformationComplete"
      v-on:action="submit"
    />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";

import SectionHeader from '../components/SectionHeader'
import Dropdown from '../components/Dropdown'
import NumberInput from '../components/NumberInput'
import YesNo from '../components/YesNo'
import Button from '../components/Button'
export default observer({
  name: 'PatientInformation',
  data() {
    return {
      store: store
    }
  },
  props: {
    edit: Boolean
  },
  components: {
    SectionHeader, Dropdown, YesNo, NumberInput, Button
  },
  created() {
    this.store.persistPatientInformation()
  },
  methods: {
    submit: function() {
      localStorage.setItem(
        "patientInformation",
        JSON.stringify(this.store.patientInformation)
      );
      if (this.edit) {
        this.$emit('close')
      } else {
        this.$router.push(`/${this.$i18n.locale}/nettdoctor/medicalhistory`)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.nettdoc-personal-information {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  &__header {
    margin-top: 10px;
  }
  &__intro {
    padding: 0 16px;
  }
}
</style>